<template>
  <div class="home">
    <InventoryOnHandList v-show="listView" @newOnHand="onClickNewFromList"  @editOnHand="onClickEditFromList" :scroll="corY" ref="refreshList"/>
    <InventoryOnHandForm v-show="formView" :inventory="inventory" @backClicked="onBackChild" @backSaveClicked="onBackSaveChild" @backClickID="onBackChildID"/>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'
import InventoryOnHandList from '@/components/inventory/InventoryOnHandList.vue'
import InventoryOnHandForm from '@/components/inventory/InventoryOnHandForm.vue'
import axios from 'axios'
import { inventoryUrl, getHeader } from '../config'

export default {
  name: 'InventoryOnHand',
  components: {
    InventoryOnHandList,
    InventoryOnHandForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      urlHistory: null,
      ref: null,
      inventory: {
        id: null,
        hand_no: null,
        hand_date: null,
        company_no: null,
        branch_no: null,
        warehouse_no: null,
        product_no: null,
        qty: null,
        uom_id: null,
        cost: null,
        total_cost: null,
        notes: null,
        status: null,
        lock: false,
        type: 'in',
        name: null,
        date_out: null,
        out_by: null,
        details: [{
          id: null,
          hand_no: null,
          hand_date: null,
          company_no: null,
          branch_no: null,
          warehouse_no: null,
          serial_number: null,
          product_no: null,
          product_description: null,
          qty_stock: null,
          uom_stock: null,
          qty: null,
          uom_id: null,
          qty_total: null,
          uom_total: null,
          cost: null,
          cost_id: null,
          notes: null,
          type: null,
          c_type: null,
          lock: false,
          used_count: null
        }],
        journals: [{
          id: null,
          level: null,
          journal_code: null,
          journal_date: null,
          status: null,
          journal_description: null,
          account_code: null,
          account: null,
          remark: null,
          debit: '0',
          credit: '0'
        }],
        logs: [{
          id: null,
          log_date: null,
          ref_no: null,
          user_id: null,
          user: null,
          description: null
        }]
      }
    }
  },
  computed: {
    ...mapState({
      uomList: state => state.uom.uomList,
      authUser: state => state.users.authUser,
      warehouseList: state => state.warehouses.warehouseList
    })
  },
  mounted () {
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getWarehouseList')
    this.$store.dispatch('getUomList')
    var payload = {
      status: null
    }
    this.$store.dispatch('getProductListSelect', payload)
  },
  methods: {
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      var warehouse = this.warehouseList.find(d => d.company_no === this.authUser.company_no)
      this.inventory = {
        id: null,
        hand_no: null,
        hand_date: new Date().toISOString(),
        company_no: this.authUser.company_no,
        branch_no: this.authUser.branch_no,
        warehouse_no: warehouse ? warehouse.warehouse_no : null,
        product_no: null,
        qty: 0,
        uom_id: null,
        cost: 0,
        total_cost: 0,
        notes: null,
        status: 'approve',
        lock: false,
        type: 'in',
        name: null,
        date_out: null,
        out_by: null,
        details: [],
        journals: [{
          id: null,
          level: null,
          journal_code: null,
          journal_date: null,
          status: null,
          journal_description: null,
          account_code: null,
          account: null,
          remark: null,
          debit: '0',
          credit: '0'
        }],
        logs: [{
          id: null,
          log_date: null,
          ref_no: null,
          user_id: null,
          user: null,
          description: null
        }]
      }
    },
    onClickEditFromList (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.inventory = value
      this.listView = false
      this.formView = true
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
    },
    async onBackSaveChild () {
      this.listView = true
      this.formView = false
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    },
    async onBackChildID (id) {
      await axios.get(inventoryUrl + '/on-hand/' + id, { headers: getHeader() })
        .then(response => {
          this.onClickEditFromList(response.data.data)
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error!!!', error.response.data.message, 'error')
        })
    }
  }
}
</script>
